/**
 * CEMEX GO API SETUP
 */

// const API_HOST_DEV = 'https://uscldcnxapmd01.azure-api.net/';

const API_HOST_DEV2 = window['API_HOST'] || 'https://dev2.cemexgo.com/api/';
const API_HOST_QA = window['API_HOST'] || 'https://qa.cemexgo.com/api/';
const API_HOST_QA2 = window['API_HOST'] || 'https://qa2.cemexgo.com/api/';
const API_HOST_PREPROD = window['API_HOST'] || 'https://pp.cemexgo.com/api/';
const API_HOST_PROD = {
  EU: window['API_HOST'] || 'https://www.cemexgo.com/api/',
  US: window['API_HOST'] || 'https://www.cemexgo.com/api/',
};
const API_HOST_DEMO = window['API_HOST'] || 'https://demo.cemexgo.com/api/';

const ApiHost = {
  DevUs: API_HOST_DEV2,
  DevEu: API_HOST_DEV2,
  Dev2Us: API_HOST_DEV2,
  Dev2Eu: API_HOST_DEV2,
  QaUs: API_HOST_QA,
  Qa2Us: API_HOST_QA2,
  QaEu: API_HOST_QA,
  Qa2Eu: API_HOST_QA2,
  PreProdUs: API_HOST_PREPROD,
  PreProdEu: API_HOST_PREPROD,
  ProdUs: API_HOST_PROD.US,
  ProdEu: API_HOST_PROD.EU,
  Demo: API_HOST_DEMO,
};

/**
 * CEMEX GO TRANSLATION SERVER SETUP
 */

// const TRANSLATE_API_HOST_DEV = {
//   EU: 'https://ukcldcnxwaadmsa01.azurewebsites.net',
//   US: 'https://uscldcnxwaadmsa01.azurewebsites.net',
// };

const TRANSLATE_API_HOST_QA = {
  EU: window['TRANSLATE_API_HOST'] || 'https://qa-eu.cemexgo.com',
  US: window['TRANSLATE_API_HOST'] || 'https://qa.cemexgo.com',
};

const TRANSLATE_API_HOST_QA2 = {
  EU: window['TRANSLATE_API_HOST'] || 'https://qa.cemexgo.com',
  US: window['TRANSLATE_API_HOST'] || 'https://qa.cemexgo.com',
};

const TRANSLATE_API_HOST_PRE_PROD = {
  EU: window['TRANSLATE_API_HOST'] || 'https://pp.cemexgo.com',
  US: window['TRANSLATE_API_HOST'] || 'https://pp.cemexgo.com',
};

const TRANSLATE_API_HOST_PROD = {
  EU: window['TRANSLATE_API_HOST'] || 'https://www.cemexgo.com',
  US: window['TRANSLATE_API_HOST'] || 'https://www.cemexgo.com',
};

const TRANSLATE_API_HOST_DEMO = window['TRANSLATE_API_HOST'] || 'https://demo.cemexgo.com';

const TranslateApiHost = {
  DevUs: TRANSLATE_API_HOST_QA.US,
  DevEu: TRANSLATE_API_HOST_QA.EU,
  Dev2Us: TRANSLATE_API_HOST_QA.US,
  Dev2Eu: TRANSLATE_API_HOST_QA.EU,
  QaUs: TRANSLATE_API_HOST_QA.US,
  Qa2Us: TRANSLATE_API_HOST_QA2.US,
  QaEu: TRANSLATE_API_HOST_QA.EU,
  Qa2Eu: TRANSLATE_API_HOST_QA2.EU,
  PreProdUs: TRANSLATE_API_HOST_PRE_PROD.US,
  PreProdEu: TRANSLATE_API_HOST_PRE_PROD.EU,
  ProdUs: TRANSLATE_API_HOST_PROD.US,
  ProdEu: TRANSLATE_API_HOST_PROD.EU,
  Demo: TRANSLATE_API_HOST_DEMO,
};

const LANGUAGE_PATH = '/translate/getLanguages';

const LanguagePath = {
  DevUs: LANGUAGE_PATH,
  DevEu: LANGUAGE_PATH,
  Dev2Us: LANGUAGE_PATH,
  Dev2Eu: LANGUAGE_PATH,
  QaUs: LANGUAGE_PATH,
  Qa2Us: LANGUAGE_PATH,
  QaEu: LANGUAGE_PATH,
  Qa2Eu: LANGUAGE_PATH,
  PreProdUs: LANGUAGE_PATH,
  PreProdEu: LANGUAGE_PATH,
  ProdUs: LANGUAGE_PATH,
  ProdEu: LANGUAGE_PATH,
  Demo: LANGUAGE_PATH,
};

const TRANSLATION_PATH = '/api/translate/translate/';

const TranslationPath = {
  DevUs: TRANSLATION_PATH,
  DevEu: TRANSLATION_PATH,
  Dev2Us: TRANSLATION_PATH,
  Dev2Eu: TRANSLATION_PATH,
  QaUs: TRANSLATION_PATH,
  Qa2Us: TRANSLATION_PATH,
  QaEu: TRANSLATION_PATH,
  Qa2Eu: TRANSLATION_PATH,
  PreProdUs: TRANSLATION_PATH,
  PreProdEu: TRANSLATION_PATH,
  ProdUs: TRANSLATION_PATH,
  ProdEu: TRANSLATION_PATH,
  Demo: TRANSLATION_PATH,
};

/**
 * GOOGLE MAPS API KEYS SETUP
 */

const GMAPS_API_KEY_DEV = window['GMAPS_KEY'] || 'AIzaSyC561hWEj6z9Ga76BtM6sUk2xLQZPvTbXM';
const GMAPS_API_KEY_DEV2 = window['GMAPS_KEY'] || 'AIzaSyCSQ5YJo3NBkAhwiFd1dxE6nnZog_Ou2fA';
const GMAPS_API_KEY_QA = window['GMAPS_KEY'] || 'AIzaSyDcucxJys1uQzt_lSI7vegk2u8h6Y1lrLQ';
const GMAPS_API_KEY_QA2 = window['GMAPS_KEY'] || 'AIzaSyCkSvVQ_8ThSA0O99pN6UNtkohjaj8pMFI';
const GMAPS_API_KEY_PRE_PROD = window['GMAPS_KEY'] || 'AIzaSyA7VsqzJ7Spu3HqoKm2-zlS4pms3p1q8EA';
const GMAPS_API_KEY_PROD = window['GMAPS_KEY'] || 'AIzaSyDrU48zz1GfEWXAElbm6mBtySOVfG6b-t4';
const GMAPS_API_KEY_DEMO = window['GMAPS_KEY'] || 'AIzaSyCW0SfqaS9YwycsgyxUgbcps3X4ZQQVl14';

const MapKey = {
  Dev: GMAPS_API_KEY_DEV,
  Dev2: GMAPS_API_KEY_DEV2,
  Qa: GMAPS_API_KEY_QA,
  Qa2: GMAPS_API_KEY_QA2,
  PreProd: GMAPS_API_KEY_PRE_PROD,
  Prod: GMAPS_API_KEY_PROD,
  Demo: GMAPS_API_KEY_DEMO,
};

const CountlyKey = {
  Dev: window['COUNTLY_KEY'] || 'cee296862763b31d121ec590e95e205b2785396f',
  Dev2: window['COUNTLY_KEY'] || 'cee296862763b31d121ec590e95e205b2785396f',
  Qa: window['COUNTLY_KEY'] || 'b895071f77965dd07421d8d492f3ab97892bab6a',
  Qa2: window['COUNTLY_KEY'] || 'ace12bc8f387233dcd08fad6b75da81f2d1c20e5',
  QaEu: window['COUNTLY_KEY'] || '5e10bef74663239904c7f99510be737b2afe44e9',
  Qa2Eu: window['COUNTLY_KEY'] || 'ace12bc8f387233dcd08fad6b75da81f2d1c20e5',
  PreProd: window['COUNTLY_KEY'] || '724210ee880361556c149088d4432c75c134a0e2',
  PreProdEu: window['COUNTLY_KEY'] || '7ef61e55e0745b3f1e0d7a8db886e5b3fb79f3ac',
  Prod: window['COUNTLY_KEY'] || '724210ee880361556c149088d4432c75c134a0e2',
  ProdEu: window['COUNTLY_KEY'] || '7ef61e55e0745b3f1e0d7a8db886e5b3fb79f3ac',
  Demo: window['COUNTLY_KEY'] || 'b895071f77965dd07421d8d492f3ab97892bab6a',
};

const AppInsightsKey = {
  DevUs: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || 'd3369fcf-1aa5-4678-b262-96b46e2ba41d',
  DevEu: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '6c8a246c-6bce-4239-af95-7656548bbd38',
  Dev2Us: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '0b3e639d-5b37-408e-b095-73a6d4b9c139',
  Dev2Eu: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '89d6298f-770e-4776-8621-da175f6d350a',
  QaUs: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || 'e6b31154-282b-4ea1-9f46-cdf598ec61e6',
  Qa2Us: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '9c4d975e-027d-4088-acdd-8aaaec8c38e5',
  QaEu: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '658839b9-4b81-4b08-a155-827a4faea705',
  Qa2Eu: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '780da933-37fc-493c-91b7-7a51e0fc44a9',
  PreProdUs: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '658841a6-47f3-45fa-b0fb-74f320869a7a',
  PreProdEu: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || 'b1f0f4d3-570c-4a02-9f22-4f08d24dc9f2',
  ProdUs: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '176eafef-dd62-4d95-8cd2-4d58f3fd2bca',
  ProdEu: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '4685dc25-5417-4d65-9624-06aa39309285',
  Demo: window['APPINSIGHTS_INSTRUMENTATIONKEY'] || '0928cf33-6f73-4065-9a96-388d673eec11',
};

const RoxKey = {
  Dev: window['ROLLOUT_KEY'] || 'f8f851e3-783a-47c2-b863-216181e59a97',
  Dev2: window['ROLLOUT_KEY'] || '3b7aa0bc-d45f-4461-93bc-9b4d274faf7f',
  Qa: window['ROLLOUT_KEY'] || 'ad4f886f-fd12-4169-99b6-079bd247031a',
  Qa2: window['ROLLOUT_KEY'] || '3748c1a6-b178-4c1b-949e-47c6f20f295c',
  PreProd: window['ROLLOUT_KEY'] || '62933eae-0339-4199-86aa-ee09d31dc697',
  Prod: window['ROLLOUT_KEY'] || '8ab8bd34-b9fb-40a7-8030-adb393fa111f',
};

const PCM_URL = {
  Dev: window['PCM URL'] || 'https://dev-pcm.cemexgo.com/cxpcmstorefront',
  Qa: window['PCM_URL'] || 'https://qa-pcm.cemexgo.com/cxpcmstorefront',
  Prod: window['PCM_URL'] || 'https://pcm.cemexgo.com/cxpcmstorefront',
};

const PcmUrl = {
  Dev: PCM_URL.Qa,
  Dev2: PCM_URL.Qa,
  Qa: PCM_URL.Qa,
  Qa2: PCM_URL.Qa,
  PreProd: PCM_URL.Prod,
  Prod: PCM_URL.Prod,
  Demo: PCM_URL.Qa,
};

export const defaultPcmRegionNames = {
  IL: 'israel_region1',
  CO: 'colombia_region1',
};

export const PcmRegionNames = {
  Dev: defaultPcmRegionNames,
  Dev2: defaultPcmRegionNames,
  Qa: defaultPcmRegionNames,
  Qa2: defaultPcmRegionNames,
  PreProd: defaultPcmRegionNames,
  Prod: defaultPcmRegionNames,
  Demo: defaultPcmRegionNames,
};

const version = require('../../package.json').version;

const WALK_ME_URL = window['WALKME_URL'] || 'https://cdn.walkme.com/users/e69507999d16467bbb091803bac288ae/';
const WALK_ME_SCRIPT = window['WALKME_SCRIPT'] || 'walkme_e69507999d16467bbb091803bac288ae_https.js';

const WALK_ME_URL_TEST = WALK_ME_URL + 'test/' + WALK_ME_SCRIPT;
const WALK_ME_URL_PROD = WALK_ME_URL + WALK_ME_SCRIPT;
const WALK_ME_URL_DEV = WALK_ME_URL + 'dev2/' + WALK_ME_SCRIPT;
const WALK_ME_URL_PP = WALK_ME_URL + 'pre-production/' + WALK_ME_SCRIPT;

const CHAT_BOT_WIZELINE_URL_TEST = window['CHATBOT_URL'] || 'https://diaspora.cemexlabs.com/js/widget.js';

const CHAT_BOT_WIZELINE_URL_PP = window['CHATBOT_URL'] || 'https://www.cemexgo.com/cdn/olivia-chatbot/PP/widget.js';

const CHAT_BOT_WIZELINE_URL_PROD = window['CHATBOT_URL'] || 'https://www.cemexgo.com/cdn/olivia-chatbot/PROD/widget.js';

const ChatbotWizelineUrl = {
  Dev: CHAT_BOT_WIZELINE_URL_TEST,
  Dev2: CHAT_BOT_WIZELINE_URL_TEST,
  Qa: CHAT_BOT_WIZELINE_URL_TEST,
  Qa2: CHAT_BOT_WIZELINE_URL_TEST,
  PreProd: CHAT_BOT_WIZELINE_URL_PP,
  Prod: CHAT_BOT_WIZELINE_URL_PROD,
  Demo: CHAT_BOT_WIZELINE_URL_TEST,
};

const WalkMeUrl = {
  Dev: WALK_ME_URL_DEV,
  Dev2: WALK_ME_URL_DEV,
  Qa: WALK_ME_URL_TEST,
  Qa2: WALK_ME_URL_TEST,
  PreProd: WALK_ME_URL_PP,
  Prod: WALK_ME_URL_PROD,
  Demo: WALK_ME_URL_PROD,
};

const OcpApimSubscriptionKey = {
  Dev: window['APIM_KEY'] || '22b60ff601534e8294d8c4376ea668f2',
  Dev2: window['APIM_KEY'] || 'bf632ba1fc31435183db5cf35c4d447a',
  Dev2EU: window['APIM_KEY'] || '426fd6305fd0463ab36b844b3e22762a',
  Qa: window['APIM_KEY'] || 'ef896930738045c6b0f11863acd92923',
  QaEU: window['APIM_KEY'] || 'cb56ffb66b0847eca18ef3402ca74c00',
  Qa2: window['APIM_KEY'] || 'a95dc1df2b6245d684610fe3213cc2da',
  PreProd: window['APIM_KEY'] || '3a46b567a3ac4edd8a00674e0430aa71',
  Prod: window['APIM_KEY'] || 'a58efa449cdf41e9bec688f342bad1b7',
  ProdEU: window['APIM_KEY'] || 'f96aadf2fbca4056b955e8ad27a714df',
  Demo: window['APIM_KEY'] || 'bf632ba1fc31435183db5cf35c4d447a',
};

export const Enviroments = {
  dev: window['DEV'] || 'development',
  dev2: window['DEV'] || 'development2',
  qa: window['DEV'] || 'quality',
  preProd: window['DEV'] || 'preproduction',
  prod: window['DEV'] || 'production',
  demo: window['DEV'] || 'demo',
  mock: window['DEV'] || 'mock',
};

const applicationCodeDev = {
  MX: 'MRD160',
  US: 'MRD160',
};

const applicationCodeDev2 = {
  MX: 'NRQ500',
  US: 'TSU010',
  GB: 'SRQ500',
};

const applicationCodeQa = {
  MX: 'NRQ500',
  US: 'TSU010',
  GB: 'SRQ500',
};

const applicationCodePrep = {
  MX: 'NR3500',
  US: 'UR3010',
};

const applicationCodeProd = {
  MX: 'NRP500',
  US: 'PRD010',
  GB: 'SRP500',
};

const applicationCode = {
  Dev: applicationCodeDev,
  Dev2: applicationCodeDev2,
  Qa: applicationCodeQa,
  PreProd: applicationCodePrep,
  Prod: applicationCodeProd,
};

export const envVars = {
  version,
  Enviroments,
  ApiHost,
  MapKey,
  CountlyKey,
  AppInsightsKey: AppInsightsKey,
  RoxKey: RoxKey,
  PcmUrl,
  PcmRegionNames,
  WalkMeUrl,
  OcpApimSubscriptionKey,
  countlyUrl: 'https://cemex.count.ly',
  appCode: 'OrderProductCat_App',
  ChatbotWizelineUrl,
  translations: {
    ApiHost: TranslateApiHost,
    LanguagePath,
    TranslationPath,
    AppName: 'ordersnproduct',
    defaultLanguage: 'en_US',
  },
  applicationCode,
  cobrowseKey: 'j6tCMcxsjbqNRQ',
};

export interface IEnvironment {
  production: boolean;
  name: string;
  version: string;
  apiHost: string;
  appCode: string;
  countlyKey: string;
  countlyUrl: string;
  mapApiKey: string;
  appInsightsKey: string;
  roxKey: string;
  pcmUrl: string;
  pcmRegionNames: { [countryCode: string]: string };
  ocpApimSubscriptionKey: string;
  walkMeUrl: string;
  chatBotWizelineUrl: string;
  translations: {
    apiHost: string;
    appName: string;
    languagePath: string;
    translationPath: string;
    defaultLanguage: string;
  };
  features: {
    uploadDocuments: boolean;
    shiftBusinessLines: boolean;
    showLanguageSelector: boolean;
  };
  applicationCode: { [countryCode: string]: string };
  cobrowseKey: string;
  ngrxDevTools: boolean;
}
